export default __webpack_public_path__ + "static/media/diet@2x.e56b421f.jpg";